import React from 'react'
import locale from 'antd/locale/pt_BR';
import { ConfigProvider } from 'antd';
import { GlobalStyle, Layout } from './components'

export default function App() {
  return (
    <ConfigProvider locale={locale}>
      <GlobalStyle />

      <Layout />
    </ConfigProvider>
  );
}
